import API from '../api/api'
import {_exportDownloadLinkDecorator} from '../helper'

const SYNC_NEW_THEME_PENDING = 'SYNC_NEW_THEME_PENDING'
const SYNC_NEW_THEME_PROGRESS = 'SYNC_NEW_THEME_PROGRESS'
const SYNC_NEW_THEME_RESPONSE = 'SYNC_NEW_THEME_RESPONSE'

const SAVE_NEW_THEME_PENDING = 'SAVE_NEW_THEME_PENDING'
const SAVE_NEW_THEME_PROGRESS = 'SAVE_NEW_THEME_PROGRESS'
const SAVE_NEW_THEME_RESPONSE = 'SAVE_NEW_THEME_RESPONSE'
const SAVE_NEW_THEME_ABORTED = 'SAVE_NEW_THEME_ABORTED'

const EXPORT_NEW_THEME_PENDING = 'EXPORT_NEW_THEME_PENDING'
const EXPORT_NEW_THEME_PROGRESS = 'EXPORT_NEW_THEME_PROGRESS'
const EXPORT_NEW_THEME_RESPONSE = 'EXPORT_NEW_THEME_RESPONSE'

const IMPORT_NEW_THEME_PENDING = 'IMPORT_NEW_THEME_PENDING'
const IMPORT_NEW_THEME_PROGRESS = 'IMPORT_NEW_THEME_PROGRESS'
const IMPORT_NEW_THEME_RESPONSE = 'IMPORT_NEW_THEME_RESPONSE'

const RESET_ERRORS = 'RESET_ERRORS'
const CLEAR_EXPORT_URLS = 'CLEAR_EXPORT_URLS'

const initialState = {
  sync_new_theme_pending: true,
  save_new_theme_pending: false,
  export_new_theme_pending: false,
  export_po_download_url: null,
  export_csv_download_url: null,
  export_advanced_csv_download_url: null,
  import_new_theme_pending: false,
  imported_entries: 0,
  strings: [],
  translation_progress: 0,
  progress: 0,
  error: false,
}

// REDUCER
export default (state = initialState, action) => {
  switch(action.type) {
    case RESET_ERRORS: {
      return {
        ...state,
        error: false,
      }
    }

    case SYNC_NEW_THEME_PENDING: {
      return {
        ...state,
        progress: 0,
        sync_new_theme_pending: true,
        export_po_download_url: null,
        export_csv_download_url: null,
        export_advanced_csv_download_url: null,
        strings: [],
        error: false,
      }
    }
    case SYNC_NEW_THEME_PROGRESS: {
      return  {
        ...state,
        progress: action.progress,
        sync_new_theme_pending: true,
      }
    }
    case SYNC_NEW_THEME_RESPONSE: {
      // A sync for the theme or language the user has left answers with that theme's strings;
      // applying it would put them under the one now on screen. Data and errors alike are
      // dropped, and the pending flag is left alone - the sync now running still owns it, so
      // the skeleton stays up instead of flashing an empty list.
      if(action.stale === true) {
        return state;
      }

      if(action.response.success === true) {
        return {
          ...state,
          sync_new_theme_pending: false,
          error: false,
          strings: action.response.strings.slice(),
          translation_progress: action.response.progress
        }
      } else {
        // strings were cleared by the pending action, so without an error this reads as an
        // empty theme - level 0 keeps the skeleton and offers the retry the creator attached
        return {
          ...state,
          sync_new_theme_pending: false,
          error: {
            message: action.response,
            action: action.action,
            level: 0,
          },
        }
      }
    }

    case SAVE_NEW_THEME_PENDING: {
      return {
        ...state,
        progress: 0,
        save_new_theme_pending: true,
        error: false,
      }
    }
    case SAVE_NEW_THEME_PROGRESS: {
      return  {
        ...state,
        progress: action.progress
      }
    }
    case SAVE_NEW_THEME_RESPONSE: {
      if(action.response.success === true) {
        // If the theme/language was switched while this save was still in flight,
        // its response no longer matches what's currently displayed - applying it
        // here would silently overwrite the newly selected language's strings.
        if(action.stale === true) {
          return {
            ...state,
            save_new_theme_pending: false,
            error: false,
          }
        }

        // A save with nothing to write answers without strings, and a response that carries
        // none says nothing about them - replacing the set here would empty the section
        return {
          ...state,
          save_new_theme_pending: false,
          error: false,
          strings: action.response.strings ? action.response.strings.slice() : state.strings,
          translation_progress: action.response.progress !== undefined
            ? action.response.progress
            : state.translation_progress
        }
      } else {
        return {
          ...state,
          save_new_theme_pending: false,
          error: {
            message: action.response,
            action: action.action,
          }
        }
      }
    }
    // A save that was dropped because the merchant left its theme or language never answers,
    // and nothing refires it the way a switch refires the sync - so the flag it set is cleared
    // here, or the overlay stays up at the percentage it reached. Not an error: the merchant
    // asked for the interruption.
    case SAVE_NEW_THEME_ABORTED: {
      return {
        ...state,
        progress: 0,
        save_new_theme_pending: false,
        error: false,
      }
    }
    case EXPORT_NEW_THEME_PENDING: {
      return {
        ...state,
        progress: 0,
        export_new_theme_pending: true,
        export_po_download_url: null,
        export_csv_download_url: null,
        export_advanced_csv_download_url: null,
        error: false,
      }
    }
    case EXPORT_NEW_THEME_PROGRESS: {
      return  {
        ...state,
        progress: action.progress
      }
    }
    case EXPORT_NEW_THEME_RESPONSE: {
      if(action.response.success == true) {
        return {
          ...state,
          progress: 100,
          export_new_theme_pending: false,
          export_po_download_url: _exportDownloadLinkDecorator(action.response.po_download_url, action.options),
          export_csv_download_url: _exportDownloadLinkDecorator(action.response.csv_download_url, action.options),
          export_advanced_csv_download_url: _exportDownloadLinkDecorator(action.response.advanced_csv_download_url, action.options),

        }
      } else {
        return {
          ...state,
          progress: 100,
          export_new_theme_pending: false
        }
      }
    }
    case IMPORT_NEW_THEME_PENDING: {
      return {
        ...state,
        progress: 0,
        import_new_theme_pending: true,
        import_cancelled: false,
        imported_entries: 0,
        error: false,
      }
    }
    case IMPORT_NEW_THEME_PROGRESS: {
      return  {
        ...state,
        progress: action.progress
      }
    }
    case IMPORT_NEW_THEME_RESPONSE: {
      // the merchant cancelled after reviewing the file, nothing was imported
      if(action.response && action.response.cancelled === true) {
        return {
          ...state,
          progress: 0,
          import_new_theme_pending: false,
          import_cancelled: true
        }
      }
      let isOk = true;
      let importedEntries = 0;
      action.response.forEach(response => {
        if(response.success !== true) {
          isOk = false
        } else {
          importedEntries += response.imported_entries
        }
      })

      if(isOk == true) {
        return {
          ...state,
          progress: 100,
          import_new_theme_pending: false,
          imported_entries: importedEntries
        }
      } else {
        return {
          ...state,
          progress: 100,
          import_new_theme_pending: false,
          imported_entries: importedEntries,
          error: {
            message: action.response.filter(response => response.success !== true),
            action: action.action,
          }
        }
      }
    }
    case CLEAR_EXPORT_URLS: {
      return {
        ...state,
        progress: 0,
        export_new_theme_pending: false,
        export_csv_download_url: null,
        export_po_download_url: null,
        export_advanced_csv_download_url: null,
      }
    }
    default:
      return state
  }
}

// ACTIONS
export const resetErrors = () => {
  return dispatch => {
    dispatch({
      type: RESET_ERRORS
    });
  }
}
export const syncNewTheme = (themeId, languageId, progress) => { 
  //console.log(`SyncNewTheme ${themeId} - ${languageId}`)
  return (dispatch, getState) => {
    dispatch({
      type: SYNC_NEW_THEME_PENDING
    })

    API.syncNewTheme(
      themeId,
      languageId,
      progress => {
        dispatch({
          type: SYNC_NEW_THEME_PROGRESS,
          progress: progress
        })
      },
      response => {
        // A dropped sync is not dispatched at all: the switch that dropped it has already
        // started the sync for the context now on screen, and that one owns the pending flag.
        if(response && response.aborted === true) {
          return
        }

        const currentState = getState()
        const stale = currentState.shop.shop.edit_language !== languageId
          || currentState.themes.edit_theme !== themeId

        dispatch({
          type: SYNC_NEW_THEME_RESPONSE,
          response: response,
          stale: stale,
          action: () => syncNewTheme(themeId, languageId, progress)
        })
      }
    )
  }
}

export const saveNewTheme = (themeId, languageId, items) => {
  return (dispatch, getState) => {
    dispatch({
      type: SAVE_NEW_THEME_PENDING
    })

    API.saveNewTheme(
      themeId,
      languageId,
      items,
      progress => {
        dispatch({
          type: SAVE_NEW_THEME_PROGRESS,
          progress: progress
        })
      },
      response => {
        if(response && response.aborted === true) {
          dispatch({
            type: SAVE_NEW_THEME_ABORTED
          })
          return
        }

        const currentState = getState()
        const stale = currentState.shop.shop.edit_language !== languageId
          || currentState.themes.edit_theme !== themeId

        dispatch({
          type: SAVE_NEW_THEME_RESPONSE,
          response: response,
          items: items,
          stale: stale,
          action: () => saveNewTheme(themeId, languageId, items)
        })
      }
    )
  }
}

export const exportNewTheme = (theme, language, options) => {
  return dispatch => {
    dispatch({
      type: EXPORT_NEW_THEME_PENDING
    })

    API.exportNewTheme(
      theme,
      options,
      language,
      progress => {
        dispatch({
          type: EXPORT_NEW_THEME_PROGRESS,
          progress: progress
        })
      },
      response => {
        dispatch({
          type: EXPORT_NEW_THEME_RESPONSE,
          response: response,
          options: options,
          action: () => exportNewTheme(theme, language, options)
        }
      )
    })
  }
}

export const importNewTheme = (file, fileType, theme, language) => {
  return dispatch => {
    dispatch({
      type: IMPORT_NEW_THEME_PENDING
    })

    API.importNewTheme(
      file,
      fileType,
      theme,
      language,
      progress => {
        dispatch({
          type: IMPORT_NEW_THEME_PROGRESS,
          progress: progress
        })
      },
      response => {
        dispatch({
          type: IMPORT_NEW_THEME_RESPONSE,
          response: response,
          action: () => importNewTheme(file, fileType, theme, language)
        }
      )
    })
  }
}

export const clearExportUrls = () => {
  return dispatch => {
    dispatch({
      type: CLEAR_EXPORT_URLS
    });
  }
}